import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, reactive } from "vue";
import type { FieldSchema, Option } from "@/models/form";
import type { Applicant } from "@/models/application";
import type { Stipulation } from "@/models/opal";
import type { StipulationInputRequest } from "@/models/api";
import BaseFormField from "@/components/shared/BaseFormField.vue";
import { $api } from "@/services/api";

interface Props {
  applicant: Applicant;
  stip: Stipulation;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmPayoffRequestInput',
  props: {
    applicant: {},
    stip: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const submittingData = ref<boolean>(false);
const confirmPayoffRequest = ref<string | undefined>(undefined);

const schema = reactive<FieldSchema>({
  type: "radio",
  hideLabel: true,
} as FieldSchema);

const options = reactive<Array<Option>>([
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
]);

async function confirmPayoff() {
  submittingData.value = true;

  if (confirmPayoffRequest.value !== undefined) {
    const request = {
      applicationStipulationId: props.stip?.id,
      applicationId: props?.stip?.applicationId,
      genericInput: {
        input: confirmPayoffRequest.value,
      },
    } as StipulationInputRequest;

    const response = await $api.applications.addStipInput(props?.stip?.applicationId, request);

    if (response?.id && response?.id > 0) {
      // updates stip status to pending
      let updatedStip = props.stip;
      updatedStip.stipulationStatusId = response.stipulationStatusId;
      updatedStip.stipulationStatusName = response.stipulationStatusName;

      emit("success", updatedStip);

      submittingData.value = false;
    } else {
      submittingData.value = false;
    }
  } else {
    submittingData.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseFormField, {
    modelValue: confirmPayoffRequest.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((confirmPayoffRequest).value = $event)),
      confirmPayoff
    ],
    schema: schema,
    options: options,
    disabled: submittingData.value
  }, null, 8, ["modelValue", "schema", "options", "disabled"]))
}
}

})